<div class="nav-header">
  <p>{{ 'DEFINE.TITLE' | translate | uppercase }}</p>
</div>
<div class="nav-list">
  @for (item of navItems; track item.route) {
    <a [routerLink]="item.route" routerLinkActive="active" class="nav-item">
      <p>{{ item.labelKey | translate }}</p>
    </a>
  }
</div>
